import { DesigntimeComponent } from './DesigntimeComponent.js'
import { LiquidString } from '../common/LiquidString.js'
import componentHelpers from './componentHelpers.js'
import * as $ from 'jquery';

class Delay extends DesigntimeComponent {
    static staticName = "Delay";
    static staticId = "delay";
    hasRuntimeView = true;
    context;

    constructor(identifyer) {
        super(identifyer, 1);

        this.hasNextButton = false;

        this.values = {
            header: new LiquidString("Default **header** text", `${this.id}_header`),
            text: new LiquidString("Default text", `${this.id}_text`),
            buttontext: { value: "Next" },
            imageurl: { value: "intro_game_changer.png", dontTranslate: true },
            imageclass: { value: "sid-image-circle", dontTranslate: true },
            delay: { value: 500, dontTranslate: true }
        };
    }

    getRuntimeView(context) {
        this.context = context;
        let $view = $("<div></div>");
        if (this.values.imageurl.value) {
            var $imagebox = $("<div class='sid-question-image'></div>");
            $imagebox.append($("<img alt=''>").addClass(this.values.imageclass.value).attr("src", context.getContentUrl() + this.values.imageurl.value));
            $view.append($imagebox);
        }
        var textbox = $("<div class='sid-question-text'></div>");

        textbox.append(this.values.header.getTag("h2", "h3").attr("tabindex", "-1"));
        textbox.append(this.values.text.getTag("p"));

        let $spinner = $(`<div class="spinner-border m-5" role="status"><span class="visually-hidden"></span></div>`);
        $spinner.find("span").text(componentHelpers.uiText(context, "si_pts_dialog_loading", "Loading…"));
        textbox.append($spinner);

        $view.append(textbox);


        if (false) {
            this.eventBroker.fire("nexButtonClickedEvent", this.nodeId);
        }

        return $view;
    }

    onNodeShown(nodeId) {
        // Wait for the fade-in, otherwise the element can't take focus yet
        setTimeout(() => $(`#${this.values.header.getUniqueId()}`).trigger("focus"), +this.context.params.fadeInDelay);

        setTimeout(() => {
            this.eventBroker.fire("nexButtonClickedEvent", nodeId);
        }, this.values.delay.value);
    }
}

export { Delay }
